module.exports = __webpack_public_path__ + "static/colgadas-003.thumb-8bdf586a8e2d4728ed8fdebc545b1b05.jpg";